import { getSessionTrackingKey, getMessagingServiceClient, getCurrentUser } from '../browser-store';
import { BrowserLogger } from './BrowserLogger';
import { SignalsErrorLoggerConfig } from './utils/javascriptLogger';

let browserLogger: BrowserLogger;
export function getBrowserLogger(): BrowserLogger {
    if (!browserLogger) {
        const { pageloadTk } = getSessionTrackingKey();
        const signalsErrorLoggerConfig: SignalsErrorLoggerConfig = {
            pageLoadTk: pageloadTk,
            priorJsErrors: window.__JS_ERROR__,
        };

        browserLogger = new BrowserLogger(
            getMessagingServiceClient(),
            pageloadTk,
            getCurrentUser(),
            signalsErrorLoggerConfig
        );
    }

    return browserLogger;
}

export { BrowserLogger } from './BrowserLogger';
